module.exports = __webpack_public_path__ + "static/media/WelcomeTea.2f7bfdaf.jpeg";